import $ from 'jquery';

/**
 * wp.media.view.MediaFrame.Post
 *
 * Extending MediaFrame.Post to add new tab
 * and logic for it in media library.
 */
export default class MediaLibrary {

    constructor() {
        if (typeof wp === "undefined" || typeof wp.Backbone === "undefined")
            return;

        var UnsplashPhoto = wp.Backbone.View.extend({
            tagName: "li",
            className: "photo",
            template: wp.template("unsplash-photo"),
            render: function() {
                this.$el.html(this.template(this.options.photo));

                return this;
            }
        });

        this.UnsplashView = wp.Backbone.View.extend({
            tagName: "div",
            className: "unsplash",
            template: wp.template("unsplash"),

            events: {
                "click #load-more" : "loadMoreClickHandler",
            },

            loadMoreClickHandler: function(e) {
                var $button = $(e.target),
                    url = $button.attr("data-unsplash-next-url");

                $button.addClass("loading");

                OPDashboard.Unsplash.getNextPage(url, function(response, headers) {
                    var photos = [];

                    response.forEach(function(photo, i) {
                        var template = new UnsplashPhoto({
                            photo: photo,
                        })

                        photos.push(template.render().$el);
                    }, this);

                    this.$el
                        .find(".frame-content button")
                        .removeClass("loading")
                        .attr("data-unsplash-next-url", headers.urls.next);

                    this.$el
                        .find(".frame-content .photos")
                        .append(photos);

                }.bind(this));
            }
        });

        var frame = wp && wp.media && wp.media.view && wp.media.view.MediaFrame ? wp.media.view.MediaFrame.Post : "";
        if (!frame)
            return;

        wp.media.view.MediaFrame.Post = frame.extend({
            initialize: function() {
                frame.prototype.initialize.apply(this, arguments);

                var State = wp.media.controller.State.extend({
                    insert: function() {
                        this.frame.close();
                    }
                })

                this.states.add([
                    new State({
                        id: "unsplash",
                        search: false,
                        title: "Unsplash"
                    })
                ]);

                this.on("content:render:unsplash", this.renderUnsplashTabContent, this);
                this.on("open", this.frameOpen, this);
            },

            /**
            * Register medialibrary tabs.
            *
            * @param  {Object} routerView
            * @return {Void}
            */
            browseRouter: function(routerView) {
                routerView.set({
                    upload: {
                        text: wp.media.view.l10n.uploadFilesTitle,
                        priority: 20
                    },
                    unsplash: {
                        text: wp.media.view.l10n.unsplashTitle,
                        priority: 30
                    },
                    browse: {
                        text: wp.media.view.l10n.mediaLibraryTitle,
                        priority: 40
                    },
                });
            },

            /**
            * Crate view from template and set it as current one.
            * (see resources/assets/views/live-editor/unsplash.php)
            *
            * @return {Void}
            */
            renderUnsplashTabContent: function() {
                OPDashboard.Unsplash.getFirstPage("popular", function(response) {
                    var view = new OPDashboard.MediaLibrary.UnsplashView({
                        photos: JSON.parse(response.photos),
                        urls: response.urls,
                    });

                    this.content.set(view);
                }.bind(this));
            },

            /**
            * Wp media frame open event handlerer.
            * Refresh attachments, because when unsplash image
            * is imported and frame is opened second time
            * imported images aren't displayed.
            *
            * @return {Void}
            */
            frameOpen: function() {
                OPDashboard.MediaLibrary._forceAttachmentsFetch();
            }
        });
    }

    /**
    * Ajax success event handler.
    * Image downloaded and imported into
    * wordpress library successfully.
    *
    * @param  {Object} response
    * @param  {String} textStatus
    * @param  {Object} jqXHR
    * @return {Void}
    */
    _handleAjaxSuccess(response, textStatus, jqXHR) {
        // Remove downloading image overlay
        wp.media.frame.$el
            .find(".unsplash .frame-content .loading")
            .removeClass("loading");

        var content = wp.media.frame.content;
        var photoId = response.data.media.ID;

        // Switch to Media Library tab
        if ("unsplash" === content.mode()) {
            content.mode("browse");
        }

        // Refresh media library to display downloaded image
        window.OPDashboard.MediaLibrary._forceAttachmentsFetch();

        // Select downloaded image in media library
        setTimeout(function() {
            var selection = wp.media.frame.state().get("selection");
            var attachment = wp.media.attachment(photoId);
            selection.add(attachment);
        }, 500);
    }

    /**
    * Force wordpress attachment fetch
    *
    * @return {Void}
    */
    _forceAttachmentsFetch() {
        var content = wp.media.frame.content;
        if (content.get() !== null && content.get().collection && content.get().options && content.get().options.selection) {
            // this forces a refresh of the content
            content.get().collection._requery(true);
            // optional: reset selection
            content.get().options.selection.reset();
        }
    }

    /**
    * Unsplash image download event handler.
    *
    * @param  {Object} element
    * @return {Void}
    */
    handleUnsplashImageClick(e, element) {
        if (e.target.nodeName === "A")
            return;

        var $element = $(element),
            url = $element.attr("data-download-url");
        var that = this;
            
        $.ajax({
            url: this.apiUrl("/media/import"),
            method: "post",
            data: {
                url: url,
            },
            beforeSend: function(xhr) {
                xhr.setRequestHeader('X-WP-Nonce', that.nonce());
                this.closest(".photo-wrapper").addClass("loading");
            }.bind($element),
            success: this._handleAjaxSuccess,
            error: function(jqXHR, textStatus, errorThrown) {
                // @todo - handle error
                alert("ERROR: " + textStatus);
            },
        });

        // After user downloaded photo
        // trigger event endpoint
        var id = $element.attr("data-photo-id");
        OPDashboard.Unsplash.download(id);
    }

    /**
    * Popular/Latest category change event handler
    * Currently not in use.
    *
    * @param  {Object} element
    * @return {Void}
    */
    handleOrderBySelectChange(element) {
        var $elem = $(element),
            order = $elem.find(":selected").attr("value");

        OPDashboard.Unsplash.getFirstPage(order, function(response) {
            var view = new OPDashboard.MediaLibrary.UnsplashView({
                photos: JSON.parse(response.photos),
                urls: response.urls,
            });

            wp.media.frame.content.set(view);
        });
    }

    /**
    * Changing image orientation filter
    *
    * @param {Object} e
    * @param {Object} element
    * @return {Void}
    */
    handleOrientationChange(e, element) {
        var element = $(element)
            .closest(".frame-content-header")
            .find('.search')
            .get(0);

        this.handleSearch(element);
    }

    /**
    * Changing query string
    *
    * @param {Object} e
    * @param {Object} element
    * @return {Void}
    */
    handleSearchKeypress(e, element) {
        if (e.keyCode !== 13)
            return;

        this.handleSearch(element);
    }

    /**
    * Unsplash search photos by given query & orientation
    *
    * @param  {Object} element
    * @return {Void}
    */
    handleSearch(element) {
        var query = $(element).val();
        var orientation = $(element)
            .closest(".frame-content-header")
            .find('.orientation')
            .val();

        OPDashboard.Unsplash.search(query, orientation, function(response) {
            var view = new OPDashboard.MediaLibrary.UnsplashView({
                query: query,
                orientation: orientation,
                photos: response.photos,
                urls: response.urls,
            });

            wp.media.frame.content.set(view);
        });
    }

    /**
     * Simply return the current nonce
     */
    nonce() {
        if (window.OpsScriptData) {
            return window.OpsScriptData.nonce;
        }

        if (window.OP3WP) {
            return window.OP3WP.nonce;
        }

        return window.OP3.Meta.nonce;
    }

    /**
     * Return URL to API
     * @param path
     */
    apiUrl(path) {
        let url = '/';

        if (window.OpsScriptData && window.OpsScriptData.apiBaseUrl) {
            url = window.OpsScriptData.apiBaseUrl + path;
        }

        else if (window.OP3WP && window.OP3WP.dashboardApiBaseUrl) {
            url = window.OP3WP.dashboardApiBaseUrl + path;
        }

        else if (window.OP3WP && window.OP3.Meta.api) {
            url = window.OP3.Meta.api + path;
        }
        console.log(url);

        return url;
    }
}
